<template>
    <section id="section">
        <div class="slider-container">
            <el-carousel indicator-position="outside" height="16vw">
                <el-carousel-item v-for="(v, k) in slides" :key="k" :style="`background-image:url(${v.thumb});`" @click.native="redirect(v)"></el-carousel-item>
            </el-carousel>
        </div>

        <div class="tab-lists-container">
            <div class="tab-title-container">
                <div class="tab-m-title-container">
                    <i class="icon-video"></i>
                    <span class="tab-m-title">街舞视频</span>
                </div>
                <ul class="tab-lists-title-box">
                    <li class="tab-lists-title">
                        <router-link :class="`tab-lists-link${sort ? '' : ' router-link-active'}`" to="/" exact>推荐</router-link>
                    </li>
                    <li class="tab-lists-title" v-for="v in sorts" :key="v.id">
                        <router-link :class="`tab-lists-link${sort === v.id ? ' router-link-active' : ''}`" :to="`/videos?sort=${v.id}`" exact>{{v.name}}</router-link>
                    </li>
                </ul>
            </div>
            <div class="tab-border-container">
                <div class="tab-s-border"></div>
                <div class="tab-m-border"></div>
            </div>
        </div>

        <!--<router-view :videos="videos" :counts="counts" :page="page"></router-view>-->
        <ul class="video-lists-box">
            <li class="video-lists" v-for="v in videos" :key="v.id">
                <!--<router-link class="video-lists-link" :to="{name: 'video', params: {id: v.id, src: v.src}}" :title="v.title">-->
                <a v-if="v.type === 1 || !v.type" class="video-lists-link" :href="`/videos/${v.id}`" target="_blank" :title="v.title">
                    <div class="pr">
                        <i class="icon-play"></i>
                        <img class="video-thumb" v-lazy="v.thumb" alt="">
                        <div class="video-thumb video-mask"></div>
                    </div>
                    <div class="video-meta-box">
                        <div class="video-title-box">
                            <h3 class="video-title ellipsis">{{v.title}}</h3>
                            <span class="video-cate ellipsis" :title="`舞蹈风格: ${v.sort}`">{{v.sort}}</span>
                        </div>
                        <p class="video-count-box">
                            <span class="video-plays" :title="`播放量: ${v.views}`">
                                <i class="icon-video"></i> {{$view(v.views)}}
                            </span>
                            <span class="video-comments" :title="`评论数: ${v.comments}`">
                                <i class="icon-comments"></i> {{v.comments}}
                            </span>
                        </p>
                    </div>
                </a>

                <a v-if="v.type === 2" class="video-lists-link" :href="`/contests/${v.id}`" target="_blank" :title="v.title">
                    <div class="pr">
                        <img class="video-thumb" v-lazy="v.thumb" alt="">
                        <div class="video-thumb video-mask"></div>
                        <div class="mark-tip">赛事</div>
                    </div>
                    <div class="video-meta-box">
                        <div class="video-title-box">
                            <h3 class="video-title ellipsis">{{v.title}}</h3>
                            <span class="video-cate ellipsis" :title="`赛事类型: ${v.sort_name}`">{{v.sort_name}}</span>
                        </div>
                        <p class="video-count-box">
                            <span class="video-plays" :title="`发布日期: ${v.addtime}`">
                                <i class="icon-clock"></i> {{v.addtime}}
                            </span>
                            <span class="video-plays" :title="`播放量: ${v.views}`">
                                <i class="icon-video"></i> {{$view(v.views)}}
                            </span>
                        </p>
                    </div>
                </a>

                <a v-if="v.type === 3" class="video-lists-link" :href="`/info/${v.id}`" target="_blank" :title="v.title">
                    <div class="pr">
                        <img class="video-thumb" v-lazy="v.thumb" alt="">
                        <div class="video-thumb video-mask"></div>
                        <div class="mark-tip">资讯</div>
                    </div>
                    <div class="video-meta-box">
                        <div class="video-title-box">
                            <h3 class="video-title ellipsis">{{v.title}}</h3>
                            <span class="video-cate ellipsis" :title="`资讯类型: ${v.sort}`">{{v.sort}}</span>
                        </div>
                        <p class="video-count-box">
                            <span class="video-plays" :title="`浏览量: ${v.views}`">
                                <i class="icon-view"></i> {{$view(v.views)}}
                            </span>
                            <span class="video-comments" :title="`评论数: ${v.comments}`">
                                <i class="icon-comments"></i> {{v.comments}}
                            </span>
                        </p>
                    </div>
                </a>

                <a v-if="v.type === 5" class="video-lists-link" :href="v.link" target="_blank" :title="v.title">
                    <div class="pr">
                        <img class="video-thumb" v-lazy="v.thumb" alt="">
                        <div class="video-thumb video-mask"></div>
                        <div class="mark-tip">广告</div>
                    </div>
                    <div class="video-meta-box">
                        <div class="advert-title">{{v.title}}</div>
                    </div>
                </a>
                <!--</router-link>-->
            </li>
        </ul>

        <el-pagination v-if="videos.length && total > 40" :current-page="page"  @current-change="currentChange" :page-size="40" :total="total" background layout="total, prev, pager, next"></el-pagination>
    </section>
</template>

<script>
    export default {
        data: () => ({
            sorts: [],
            slides: [],
            videos: [],
            total: 0,
        }),
        computed: {
            sort() {
                return +this.$route.query.sort || 0;
            },
            page() {
                return +this.$route.query.page || 1;
            }
        },
        methods: {
            redirect(v) {
                switch(v.type) {
                    case 1: this.$router.push(`/videos/${v.id}`);break;
                    case 2: this.$router.push(`/contests/${v.id}`);break;
                    case 3: this.$router.push(`/info/${v.id}`);break;
                    default: window.open(v.link);
                }
            },
            currentChange(page) {// 页码改变
                this.$router.push(`/videos?sort=${this.sort}&page=${page}`);
            },
        },
        beforeMount() {
            let {api, sort, page} = this;

            Promise.all([
                api.get(`home/slides`).then(e => this.slides = e),
                api.get('home/sorts').then(e => this.sorts = e),
                api.get('videos', {sort, page}).then(e => this.videos = e),
                api.get('videos/count', {sort}).then(e => this.total = e)
            ]).catch(this.err);
        },
        beforeRouteUpdate(to, from, next) {// 路由改变前，组件就已经渲染完了
            const {api} = this;
            let {sort, page} = to.query;
            page = +page || 1;
            sort = +sort || 0;

            Promise.all([
                api.get('videos', {sort, page}).then(e => this.videos = e),
                api.get('videos/count', {sort}).then(e => this.total = e)
            ]).catch(this.err);
            next();
        },
        /* watch: {
             '$route' (to) {// 因为相同组件只能触发beforeRouteEnter 不能触发update 所以只能使用监听的方式实现路由更新
                 this.load(to)
             }
         },
         created() {
             this.load(this.$route)
         },*/
    }
</script>

<style scoped>
    @import "../../../static/css/common/tab.css";
    @import "../../../static/css/common/lists.css";
    @import "../../../static/css/views/home/lists.css";
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue